import { render, staticRenderFns } from "./FiltrosMeusPendentes.vue?vue&type=template&id=71753882&scoped=true&"
import script from "./FiltrosMeusPendentes.vue?vue&type=script&lang=js&"
export * from "./FiltrosMeusPendentes.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosMeusPendentes.vue?vue&type=style&index=0&id=71753882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71753882",
  null
  
)

export default component.exports